import { render, staticRenderFns } from "./AccessWalletLedger.vue?vue&type=template&id=6c279b1c&scoped=true"
import script from "./AccessWalletLedger.vue?vue&type=script&lang=js"
export * from "./AccessWalletLedger.vue?vue&type=script&lang=js"
import style0 from "./AccessWalletLedger.vue?vue&type=style&index=0&id=6c279b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c279b1c",
  null
  
)

export default component.exports